export const MEALS = ["Breakfast", "Lunch", "Dinner", "Snack"];
